import { PAGE_SIZE_DEFAULT } from "app/appConfig";

export class BaseSearchObject {
  pageIndex = 1;
  pageSize = PAGE_SIZE_DEFAULT || 10;
  keyword = null;

  constructor(value) {
    Object.assign(this, value);
  }
}

export class SearchObject extends BaseSearchObject {
  id = null;
  fromDate = null;
  toDate = null;
  date = null;
  voided = null;
  type = null;
  isUse = null;

  constructor(value) {
    super(value);
    Object.assign(this, value);
  }
}

export class SearchVat extends BaseSearchObject {
  fromDate = null;
  isDefault = null;
  isUsing = null;
  toDate = null;
  vatPercent = null;
}

export class SearchAdministrativeUnit extends SearchObject {
  parentId = null;
  level = null;
  //isGetUserLogin= false; //có lấy danh sách theo user login hay không
  regionId = null;
  provinceId = null;
  districtId = null;
  communeId = null;
}

export class SearchPatient extends SearchObject {
  gender = null; // gioi tinh
  province = null; //tinh
  district = null; //quan/huyen
  commune = null; //phuong xa
  street = null; // duong
  birthdate = null; // ngay sinh
  nationalId = null; //cccd
  tab = 0;
  code = null;
  status = null;
  // fromDate = new Date();
  // toDate = new Date();
  typeSearch = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchExamReg extends SearchObject {
  name = null;
  // fromDate = new Date();
  // toDate = new Date();
  tab = 0;
  typeOrder = 0;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchVisit extends SearchObject {
  name = null;
  tab = 0;
  visitStatus = null;
  subclinicalStatus = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchDocumentHolderIndex extends SearchObject {
  name = null;
  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchInvoice {
  invoiceStatus = null;
  visitId = null;
  episodeOfCareId = null;
  patientId = null;
  typeSearch = null;
}

export class SearchEncounterExam extends SearchObject {
  encounterTypeId = null;
  roomId = null; // phong kham
  patientCode = null; //tinh
  fromDate = new Date();
  toDate = new Date();

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchTreamentProcess extends SearchObject {
  tab = 0;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchUserAccount extends SearchObject {
  organizationId = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchHealthCareService extends SearchObject {
  serviceTypeId = null;
  serviceTypeCode = null;
  serviceGroupId = null;
  vatIncluded = null;
  priceFrom = null;
  priceTo = null;
  patientTypeServiceIds = [];
  departmentApplyIds = [];
  isHasCostNorm = null;
  isHasRevenueAllocation = null;
  isHasWarranty = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchDrug extends SearchObject {
  priceFrom = null;
  priceTo = null;
  patientTypeServiceIds = [];
  departmentApplyIds = [];
  isHasCostNorm = null;
  isHasRevenueAllocation = null;
  isHasWarranty = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchClientCard extends SearchObject {
  priceFrom = null;
  priceTo = null;
  patientTypeServiceIds = [];
  departmentApplyIds = [];
  isHasCostNorm = null;
  isHasRevenueAllocation = null;
  isHasWarranty = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchTreatmentPlanCard extends SearchObject {
  priceFrom = null;
  priceTo = null;
  patientTypeServiceIds = [];
  departmentApplyIds = [];
  isHasCostNorm = null;
  isHasRevenueAllocation = null;
  isHasWarranty = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchStaff extends SearchObject {
  gender = null; // gioi tinh
  birthdate = null; // ngay sinh
  tab = 0;
  code = null;
  status = null;
  departmentId = null;
  deptIdOfStaffInRoom = null;
  roomId = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchPatientInvoice extends SearchPatient {
  invoiceStatus = null;
  fromDate = new Date();
  toDate = new Date();

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchPatientList extends BaseSearchObject {
  fromDate = new Date();
  toDate = new Date();

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchStoreRequest extends SearchObject {
  code = null;
  depCode = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchHICost extends SearchObject {
  visitId = null;
  patientId = null;
  episodeOfCareId = null;
  constructor(value) {
    super();
    Object.assign(this, value);
  }
}
export class SearchVoucher extends SearchObject {
  fromDate = new Date();
  toDate = new Date();
  paymentSource = null;
  code = null;
  voucherType = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchEstimateDrug extends SearchObject {
  code = null;
  estimatedDate = null;
  fromDate = null;
  toDate = null;
  department = null;
  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchInpatientByDepartment extends SearchObject {
  department = null;
  listPatientId = [];
  fromDate = new Date();
  toDate = new Date();

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchStockOut extends SearchObject {
  department = null;
  stockOutDate = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}
export class SearchPatientAppointmentList extends BaseSearchObject {
  fromDate = null;
  toDate = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchRequestNumber extends SearchObject {
  roomId = null; // phong kham
  patientCode = null;
  date = null;
  isRegistered = null;
  sortBy = null;
  statusRequestNumRoom = 1;
  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchPatientListByUser extends SearchObject {
  tab = 0;
  code = null;
  fromDate = null;
  toDate = new Date();
  // toDate = null;
  typeSearch = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchPatientRegistration extends BaseSearchObject {
  fromDate = new Date();
  toDate = new Date();
  roomId = null;
  room = null;
  applicableObject = null;

  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchServiceTreatment extends BaseSearchObject {
  patientId = null;
  groupId = null; //nhom dv/lieu trinh/san pham
  treatmentPlanCardId = null; //the/lieu trinh
  svItemStatus = null; //trang thai dich vu dang ky
  treatmentPlanCardStatus = null; //trang thai cua lieu trinh/the
  healthCareSvId = null; //id cua dich vu


  // Tìm kiếm các dịch vụ đã chỉ định cho bệnh nhân
  orderDateFrom = null; // Thời gian chỉ định từ
  orderDateTo = null; // Thời gian chỉ định đến
  performDateFrom = null; // Thời gian thực hiện từ
  performDateTo = null; // Thời gian thực hiện đến
  roomId = null; // Phòng thực hiện
  departmentId = null; // Cơ sở thực hiện
  itemStatus = null; // Trạng thái thực hiện
  constructor(value) {
    super();
    Object.assign(this, value);
  }
}

export class SearchPromotionProgram extends BaseSearchObject {
  fromDate = null;
  toDate = null;
}


export class SearchSalaryPeriod extends BaseSearchObject {
  fromDate = null;
  toDate = null;
}

export class SearchEmployeeStatus extends BaseSearchObject {
  fromDate = null;
  toDate = null;
}

export class SearchStaffGroup extends BaseSearchObject {
  fromDate = null;
  toDate = null;
}

